import { AxiosInstance } from 'axios';
import { ShareMyWishOrderSpaces } from 'core/ShareMyWishOrder';
import client from './RestClient';

export interface ShareMyWishOrderWebService {
  getCampaignSpacesWithin(
    startDate?: string,
    endDate?: string
  ): Promise<ShareMyWishOrderSpaces[]>;
}

export class RestfulShareMyWishOrderWebService implements ShareMyWishOrderWebService {
  restClient: AxiosInstance;

  constructor(restClient: AxiosInstance = client) {
    this.restClient = restClient;
  }

  getCampaignSpacesWithin = async (
    startDate?: string,
    endDate?: string
  ): Promise<ShareMyWishOrderSpaces[]> => {
    const query: string[] = [];
    if (startDate) query.push(`startDate=${startDate}`);
    if (endDate) query.push(`endDate=${endDate}`);
    const queryString = query.length > 0 ? `?${query.join('&')}` : '';
    const response = await this.restClient.get(
      `/share-my-wish/campaigns/spaces${queryString}`
    );
    return response.data.records.map(
      (record: { date: string; spaces: SelectOptions[] }) => ({
        date: record.date,
        spaces: record.spaces.map((space) => space.value.toString())
      })
    );
  };
}
